import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationTest: React.FC = () => {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const testItems = [
    { name: 'Dashboards', href: '/dashboards', subItems: [
      { name: 'Executive Dashboard', href: '/dashboards' },
      { name: 'Orders Dashboard', href: '/dashboards/orders' },
      { name: 'Supply Chain Dashboard', href: '/dashboards/supply-chain' }
    ]},
    { name: 'Inventory', href: '/inventory', subItems: [
      { name: 'Stock Levels', href: '/inventory' },
      { name: 'Medicine Catalog', href: '/catalog' }
    ]},
    { name: 'Orders', href: '/orders', subItems: [
      { name: 'Order Management', href: '/orders' }
    ]}
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Navigation Test</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Current Location</h2>
          <p className="text-gray-600">Path: <code className="bg-gray-100 px-2 py-1 rounded">{location.pathname}</code></p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Test Navigation</h2>
          <div className="flex space-x-4">
            {testItems.map((item) => (
              <div 
                key={item.name}
                className="relative"
                onMouseEnter={() => setHoveredItem(item.name)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors">
                  {item.name}
                </button>
                
                {item.subItems && hoveredItem === item.name && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                    {item.subItems.map((subItem) => (
                      <a
                        key={subItem.href}
                        href={subItem.href}
                        className="block px-4 py-3 hover:bg-gray-50 transition-colors"
                      >
                        {subItem.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Navigation State</h2>
          <p className="text-gray-600">Hovered Item: <code className="bg-gray-100 px-2 py-1 rounded">{hoveredItem || 'None'}</code></p>
        </div>
      </div>
    </div>
  );
};

export default NavigationTest;
